module.exports = function (bootstrap) {

    "use strict";

    bootstrap.directive('providerDetails', function () {

        return {

            scope: {
                details: "=",
                perObject: "=?",
                glossaryItems: '=?',
                coreMetricsConfig: "="   //for coremetrics
            },

            replace: true,
            template: require('articles/providers/providerDetails/providerDetails.html'),

            controller: ['$scope', '$rootScope', '$state', 'modal', 'glossary', 'coremetrics', 'sessionData', '$location', '$anchorScroll', 'parseProviderDetails', 'services',

                function ($scope, $rootScope, $state, modal, glossary, coremetrics, sessionData, $location, $anchorScroll, parseProviderDetails, services) {

                    $scope.hospitalCompareUrl = "https://www.medicare.gov/hospitalcompare/search.html";

                    services.cprsvc.medicalVendorExternalIdentifier().fetch($state.params.vendorId).then(function (response) {
                        if (response && response.data && response.data.MedicalVendorExternalIdentifierResponse && response.data.MedicalVendorExternalIdentifierResponse.medicalVendorExternalIdentifier) {
                            var n = parseInt(response.data.MedicalVendorExternalIdentifierResponse.medicalVendorExternalIdentifier);
                            if (n < 970000 || n > 999999) {
                                // not in dummy range
                                $scope.hospitalCompareUrl = "https://www.medicare.gov/hospitalcompare/profile.html?profTab=0&ID=" + response.data.MedicalVendorExternalIdentifierResponse.medicalVendorExternalIdentifier;
                            }
                        }
                    });

                    var details = angular.copy($scope.details), //copy of passed in object - prevents accidental editing of original object


                        features = parseProviderDetails.filterFeatures(details.selectedLocation.features),

                        //this is required to be true to allow linking to glossary
                        glossaryItemsExist = !!($scope.glossaryItems && $scope.glossaryItems.data && $scope.glossaryItems.data.length),

                        keyDefined = function (key) {
                            return !!(sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER &&
                            sessionData.appConfig.PROVIDER[key] && sessionData.appConfig.PROVIDER[key].booleanValue);
                        },


                        //defines whether or not individual drawers exist
                        defineDrawerConfig = function () {

                            $scope.drawerConfig = {

                                showAffiliatedHospitals: !!($scope.parsedDetails.hospitalAffiliation.length),
                                showAreaOfInterest: !!($scope.isProfessional && $scope.parsedDetails.areaOfInterest.length),
                                showPatientReviews: !!($scope.parsedDetails.features.allowPatientReview === 'TRUE' &&
                                sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER &&
                                sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_ENABLE_PER'] &&
                                sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_ENABLE_PER'].booleanValue),

                                //this should always show when it's a professional because board certifications always need to show
                                showPhysicianBoardCertified: !!( keyDefined($scope.coreMetricsConfig.subApp + '_SUPPRESS_BOARD_CERT') ? !!($scope.isProfessional && details.boardCertified && details.boardCertified.length > 0) : true),

                                showPhysicianRecognitions: !!(keyDefined($scope.coreMetricsConfig.subApp + '_SUPPRESS_BOARD_CERT') ? !! (($scope.isProfessional && details.boardCertified && details.boardCertified.length > 0)  || ($scope.isProfessional && $scope.parsedDetails.qualityMeasures &&
                                $scope.parsedDetails.qualityMeasures.recognitions && $scope.parsedDetails.qualityMeasures.recognitions.length) )  : !!($scope.isProfessional)),


                                showFacilityRecognitions: !!(!$scope.isProfessional && ($scope.parsedDetails.qualityMeasures &&
                                $scope.parsedDetails.qualityMeasures.recognitions && $scope.parsedDetails.qualityMeasures.recognitions.length)),

                                showPlansAccepted: true,

                                showMedicare: !!($scope.parsedDetails.medicareRating > -1 && keyDefined($scope.coreMetricsConfig.subApp + '_ENABLE_CMS')),

                                showPhysicianInformation: !!($scope.isProfessional && ($scope.parsedDetails.professionalInfo.gender ||
                                $scope.parsedDetails.professionalInfo.languagesSpoken || $scope.parsedDetails.features.pcpEligible ||
                                $scope.parsedDetails.professionalEducation.length > 0)),

                                showOtherLocations: !!($scope.parsedDetails.otherLocations.length),

                                showAccreditations: !!($scope.parsedDetails.qualityMeasures.accreditations &&
                                $scope.parsedDetails.qualityMeasures.accreditations.length > 0 ||
                                $scope.parsedDetails.selectedLocation.hospital)

                            };

                        },

                        selectedLocation = {},

                        professionalInfo = {},

                        NA = "Information Not Available"; //todo - put in teamsite

                    $scope.isProfessional = !!(details.professionalInfo.displayName);
                    $scope.isVendor = !!(details.type === 'Vendor' || details.type === 'G');

                    //send to other pages so you know where you came from
                    $scope.referrer = {
                        practitionerId: $state.params.practitionerId,
                        vendorId: $state.params.vendorId,
                        locationSequenceNumber: $state.params.locationSequenceNumber,
                        vendorType: $state.params.vendorType,
                        productId: $state.params.productId
                    };

                    function defineParsedDetails() {
                        //Parsed version of details
                        $scope.parsedDetails = angular.copy(details);

                        features.pcpEligible = parseProviderDetails.parsePcpEligibleStatus(angular.copy(features.pcpEligible));
                        features.electronicPrescription = parseProviderDetails.parseElectronicPrescription(angular.copy(features.electronicPrescription));
                        features.electronicMedicalRecords = angular.copy(features.electronicMedicalRecords) === 'TRUE' ? 'Yes' : NA;
                        features.handicapAccess = angular.copy(features.handicapAccess);
                        features.parkingDetails = features.parkingDetails && features.parkingDetails !== 'FALSE' && features.parkingDetails !== "Info N/A"  ? angular.copy(features.parkingDetails) : NA;

                        selectedLocation.onSiteStaff = details.selectedLocation.onSiteStaff && details.selectedLocation.onSiteStaff.join(", ") || NA;
                        selectedLocation.assistiveAids = details.selectedLocation.assistiveAids && details.selectedLocation.assistiveAids.sort(parseProviderDetails.alphaSort).join(", ") || NA;
                        selectedLocation.servicesOnSite = details.selectedLocation.servicesOnSite && details.selectedLocation.servicesOnSite.sort(parseProviderDetails.alphaSort).join(", ") || NA;
                        selectedLocation.patientAgeRangeAccepted = parseProviderDetails.parsePatientAgeRangeAccepted(details.selectedLocation);

                        professionalInfo.gender = details.professionalInfo.gender || NA;
                        professionalInfo.languagesSpoken = details.professionalInfo.languagesSpoken && details.professionalInfo.languagesSpoken.join(", ") || NA;

                        $scope.parsedDetails.features = features;
                        $scope.parsedDetails.selectedLocation = angular.extend({}, details.selectedLocation, selectedLocation); //shallow copy
                        $scope.parsedDetails.professionalInfo = angular.extend({}, details.professionalInfo, professionalInfo); //shallow copy

                        $scope.parsedDetails.plansAccepted = details.plansAccepted && details.plansAccepted.sort(parseProviderDetails.alphaSort) || [];

                        $scope.parsedDetails.qualityMeasures = details.qualityMeasures || {};
                        $scope.parsedDetails.qualityMeasures.accreditations = [];

                        //todo - This recs/accreds parsing should be done at the service layer!
                        $scope.parsedDetails.qualityMeasures.accreditations = parseProviderDetails.createFacilityAccreditationsObject(angular.copy(details.qualityMeasures));
                        $scope.parsedDetails.qualityMeasures.recognitions = parseProviderDetails.createFacilityRecognitionsObject(angular.copy(details.qualityMeasures));

                        //After the details are defined, then parse
                        if (glossaryItemsExist) {
                            $scope.parsedDetails.qualityMeasures.accreditations = parseProviderDetails.parseQualityMeasures($scope.parsedDetails.qualityMeasures.accreditations, $scope.glossaryItems);
                        }
                        //todo - Blue distinction total care name change is done as a temp fix from UI later it will be done from service side.
                        if (glossaryItemsExist) {
                                var recognitions = parseProviderDetails.parseQualityMeasures($scope.parsedDetails.qualityMeasures.recognitions, $scope.glossaryItems);
                                if(recognitions && recognitions.length>0){
                                    for(var i=0;i<recognitions.length;i++){
                                        if(recognitions[i].name){
                                            recognitions[i].name = recognitions[i].name.replace('Blue Distinction Total Care','Total Care');
                                        }
                                    }
                                }
                            $scope.parsedDetails.qualityMeasures.recognitions = recognitions;
                        }
                        if (glossaryItemsExist) {
                            $scope.parsedDetails.qualityMeasures.showAmbulatoryDisclaimer = parseProviderDetails.showAmbulatoryDisclaimer($scope.parsedDetails.qualityMeasures.recognitions);
                        }
                        $scope.parsedDetails.showPhysicianId = !!(keyDefined($scope.coreMetricsConfig.subApp + '_ENABLE_PHYSID') && details && details.selectedLocation && details.selectedLocation.fivePartKey && details.selectedLocation.fivePartKey.providerId && $scope.parsedDetails.features.pcpEligible === 'Yes');
                        $scope.parsedDetails.showPrimaryCareClinicId = !!(keyDefined($scope.coreMetricsConfig.subApp + '_ENABLE_PCCID') && details.selectedLocation && details.selectedLocation.legacyVendorId);

                        $scope.parsedDetails.medicareRating = details.selectedLocation && details.selectedLocation.cmsStarsRating;
                        $scope.parsedDetails.boardCertified = details.boardCertified && details.boardCertified.length > 0 ? details.boardCertified.sort(parseProviderDetails.alphaSort).join(", ") : "None";

                        $scope.parsedDetails.otherLocations = details.otherLocations || [];
                        $scope.parsedDetails.professionalEducation = details.professionalEducation || [];
                        $scope.parsedDetails.hospitalAffiliation = details.hospitalAffiliation || [];
                    }

                    $scope.limit = 2;
                    $scope.isOpenPR = $state.params.isOpenPR;
                    $scope.submitted = $state.params.submitted;

                    $scope.toggleDetailDrawer = function (drawerBool, drawerCoremetricsName) {
                        $scope[drawerBool] = !$scope[drawerBool];
                        broadcastDrawerEvent(drawerBool, $scope[drawerBool]);
                        parseProviderDetails.triggerCoremetricsOnDetailDrawerToggle(drawerCoremetricsName, $scope[drawerBool], $scope.coreMetricsConfig.categoryId);
                    };

                    $scope.goToDetails = function (title, vendorId, locationSequenceNo) {
                        if (title) {
                            coremetrics.elementTag($scope.coreMetricsConfig.categoryId + ':DETAILS:OTHER LOCATIONS:' + title.toUpperCase(), $scope.coreMetricsConfig.categoryId + ':DETAILS');
                        }

                        $state.go('providers', {
                            practitionerId: $scope.parsedDetails.professionalInfo.practitionerId,
                            vendorId: vendorId,
                            locationSequenceNumber: locationSequenceNo,
                            vendorType: $state.params.vendorType,
                            productId: $state.params.productId,
                            isOpenPR: false,
                            submitted: false,
                            openLocations: false,
                            displayName: $scope.parsedDetails.professionalInfo.displayName,
                            referrer: $scope.referrer
                        }, {location: true});
                    };

                    $scope.goToDisclaimer = function () {

                        coremetrics.elementTag($scope.coreMetricsConfig.categoryId + ':DETAILS:PHYSICIAN WRITE A REVIEW', $scope.coreMetricsConfig.categoryId + ':DETAILS');

                        $state.go('providers.reviewDisclaimer', {
                            details: $scope.parsedDetails || null,
                            displayName: $scope.parsedDetails.professionalInfo.displayName || null,
                            practitionerId: $scope.parsedDetails.professionalInfo.practitionerId || null,
                            vendorId: $scope.parsedDetails.selectedLocation.vendorId || null,
                            vendorType: $state.params.vendorType,
                            locationSequenceNumber: $scope.parsedDetails.selectedLocation.locationSequenceNo || null,
                            productId: $state.params.productId || null,
                            referrer: $scope.referrer
                        });
                    };

                    $scope.goToReviews = function () {

                        coremetrics.elementTag($scope.coreMetricsConfig.categoryId + ':DETAILS:PHYSICIAN SEE ALL REVIEWS', $scope.coreMetricsConfig.categoryId + ':DETAILS');

                        $state.go('providers.allReviews', {
                            displayName: $scope.parsedDetails.professionalInfo.displayName || null,
                            practitionerId: $scope.parsedDetails.professionalInfo.practitionerId || null,
                            vendorId: $scope.parsedDetails.selectedLocation.vendorId || null,
                            vendorType: $state.params.vendorType,
                            locationSequenceNumber: $scope.parsedDetails.selectedLocation.locationSequenceNo || null,
                            productId: $state.params.productId || null,
                            referrer: $scope.referrer
                        });
                    };

                    $scope.goToGlossary = function (source, id, title) {

                        console.debug('source: ' + source);
                        console.debug('id: ' + id);
                        console.debug('title: ' + title);

                        var coremetricsIdentifier;

                        if (title) {
                            switch (source) {
                                case 'rec':
                                    coremetricsIdentifier = 'RECOGNITION';
                                    break;
                                case 'accred':
                                    coremetricsIdentifier = 'ACCREDITATION';
                                    break;
                                default:
                                    coremetricsIdentifier = 'RECOGNITION';
                                    break;
                            }

                            coremetrics.elementTag($scope.coreMetricsConfig.categoryId + ':DETAILS:' + coremetricsIdentifier + ' ' +
                                title.toUpperCase(), $scope.coreMetricsConfig.categoryId);

                        }

                        //added brandName for domain independent handling
                        $state.go('glossary', {
                            details: {
                                id: id,
                                displayName: $scope.parsedDetails.professionalInfo.displayName,
                                practitionerId: $scope.parsedDetails.professionalInfo.practitionerId,
                                vendorId: $scope.parsedDetails.selectedLocation.vendorId,
                                vendorType: $state.params.vendorType,
                                locationSequenceNumber: $scope.parsedDetails.selectedLocation.locationSequenceNo,
                                brandName: $state.params.brandName,
                                productId: $state.params.productId,
                                referrer: $scope.referrer
                            }
                        });
                    };

                    $scope.openDisclaimer = function () {
                        modal.open({
                            template: require('modals/recognitionDisclaimer.html')
                        });
                    };

                    $scope.openDisclaimerBDC = function () {
                        modal.open({
                            template: require('modals/BDCDisclaimer.html')
                        });
                    };

                    function initialize() {

                        defineParsedDetails();
                        defineDrawerConfig();

                        $scope.isOpenOL = $state.params.openLocations;
                        $scope.isOpenPhR = $state.params.openRecognitions;

                        if ($scope.isOpenOL) {
                            $location.hash('otherLocations');
                            $anchorScroll();
                        }

                        if ($scope.isOpenPhR) {
                            $location.hash('recognitions');
                            $anchorScroll();
                        }

                    }

                    //these two functions allow the drawers on compare to open simultaneously
                    function broadcastDrawerEvent(drawerBooleanProperty, drawerBooleanValue) {
                        $rootScope.$broadcast('drawerOpenCloseEvent', {
                            property: drawerBooleanProperty,
                            value: drawerBooleanValue
                        });
                    }

                    $scope.$on('drawerOpenCloseEvent', function (event, args) {
                        $scope[args.property] = args.value;
                    });

                    initialize();

                }
            ]
        };
    });
};